import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=b86af196&scoped=true"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"
import style0 from "./EventView.vue?vue&type=style&index=0&id=b86af196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86af196",
  null
  
)

export default component.exports